/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CurrencyEnum } from './currencyEnum';

export interface Rate { 
    _id?: string;
    rateId?: string;
    merchantName?: string;
    merchantId?: string;
    rateName?: string;
    currency?: CurrencyEnum;
    createdOn?: Date;
    effectiveDate?: Date;
    terminationDate?: Date;
    isDedicated?: boolean;
    isDeleted?: boolean;
    isExpired?: boolean;
    isExtended?: boolean;
}